import React, { useState, useEffect } from "react";
import {
	Modal,
	Form,
	Select,
	DatePicker,
	Input,
	Button,
	message,
	Typography,
	Checkbox,
} from "antd";
import useAxios from "../../utilities/useAxios";
import dayjs from "dayjs";
import useIsMobile from "../../hooks/useIsMobile";

const { Option } = Select;

const EditBaptismalStatusModal = ({
	visible,
	onCancel,
	onSuccess,
	userId,
	currentBaptismalStatus,
}) => {
	const isMobile = useIsMobile();
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [baptismalStatuses, setBaptismalStatuses] = useState([]);

	useEffect(() => {
		if (visible) {
			getBaptismalStatuses();
			form.setFieldsValue({
				baptismal_status_type: currentBaptismalStatus,
				baptismal_date: dayjs(),
				will_change_status: true,
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps -- form is stable
	}, [visible, currentBaptismalStatus]);

	const getBaptismalStatuses = async () => {
		try {
			const response = await useAxios.get(
				"/users/baptismal-statuses/"
			);
			if (response.status === 200) {
				setBaptismalStatuses(response.data);
			}
		} catch (error) {
			message.error(
				"세례상태 목록을 불러오는데 실패했습니다."
			);
		}
	};

	const handleSubmit = async () => {
		try {
			setLoading(true);
			const values = await form.validateFields();

			const updateData = {
				baptismal_status: values.baptismal_status_type,
				baptismal_change: {
					baptismal_status_type:
						values.baptismal_status_type,
					baptismal_date:
						values.baptismal_date.format(
							"YYYY-MM-DD"
						),
					baptizing_pastor:
						values.baptizing_pastor || "",
					baptismal_church:
						values.baptismal_church || "",
				},
				will_change_status: values.will_change_status,
			};

			const response = await useAxios.put(
				`/users/update-baptismal-status/${userId}/`,
				updateData
			);

			if (response.status === 200) {
				message.success(
					"세례상태가 성공적으로 수정되었습니다."
				);
				onSuccess();
				form.resetFields();
			}
		} catch (error) {
			message.error("세례상태 수정에 실패했습니다.");
		} finally {
			setLoading(false);
		}
	};

	const handleCancel = () => {
		form.resetFields();
		onCancel();
	};

	return (
		<Modal
			title="세례상태 수정"
			open={visible}
			onCancel={handleCancel}
			footer={[
				<Button key="cancel" onClick={handleCancel}>
					취소
				</Button>,
				<Button
					key="submit"
					type="primary"
					loading={loading}
					onClick={handleSubmit}>
					수정
				</Button>,
			]}
			width={500}>
			<Form form={form} layout="vertical">
				<Form.Item
					name="baptismal_status_type"
					label="세례상태"
					rules={[
						{
							required: true,
							message: "세례상태를 선택해주세요",
						},
					]}>
					<Select placeholder="세례상태 선택">
						{baptismalStatuses.map(
							(status) => (
								<Option
									key={
										status.id
									}
									value={
										status.name
									}>
									{
										status.name
									}
								</Option>
							)
						)}
					</Select>
				</Form.Item>

				<Form.Item
					name="baptismal_date"
					label="세례일"
					rules={[
						{
							required: true,
							message: "세례일을 선택해주세요",
						},
					]}>
					<DatePicker
						inputReadOnly={isMobile}
						style={{ width: "100%" }}
						format="YYYY-MM-DD"
						placeholder="세례일 선택"
					/>
				</Form.Item>

				<Form.Item
					name="baptizing_pastor"
					label="세례 목사">
					<Input placeholder="세례 목사명을 입력해주세요" />
				</Form.Item>

				<Form.Item
					name="baptismal_church"
					label="세례 교회">
					<Input placeholder="세례 교회명을 입력해주세요" />
				</Form.Item>
				<Form.Item
					name="will_change_status"
					label="교인상태 변경 여부">
					<Checkbox
						defaultChecked={true}
						onChange={(e) =>
							form.setFieldsValue({
								will_change_status:
									e.target
										.checked,
							})
						}>
						세례상태 변경 후 교인상태 변경
					</Checkbox>
				</Form.Item>
			</Form>
		</Modal>
	);
};

export default EditBaptismalStatusModal;
